import Highland from 'highland';

type PushFunc<T> = (error: Error | null, value?: T | typeof Highland.nil) => void;

type ConsumerFunc<V, R> = (
  error: Error,
  value: V | typeof Highland.nil,
  push: PushFunc<R>,
  next: () => void,
) => Promise<void>;

export const consumer = <V, R = V>(func: ConsumerFunc<V, R>): ConsumerFunc<V, R> => {
  return async (error: Error, value: V | typeof Highland.nil, push: PushFunc<R>, next: () => void) => {
    try {
      if (error) {
        push(error, Highland.nil);
        return;
      }

      await func(error, value, push, next);
    } catch (e: any) {
      push(e, Highland.nil);
    }
  };
};
